import { createDeviceTelemetrySaga } from '../Telemetry/deviceTelemetrySagas';
import { DeviceTelemetryType } from '@signageos/common-types/dist/Device/Telemetry/DeviceTelemetryType';
import IGetTelemetryProperties from '../Telemetry/IGetTelemetryProperties';
import { MonitoringLogData } from '@signageos/common-types/dist/Device/MonitoringLog/MonitoringLogData';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import Responsibility from '../../../Feature/Responsibility';
import { IResponsibilities } from '../../../Feature/Responsibilities';
import IManagementDriver from '../../../NativeDevice/Management/IManagementDriver';
import { IPropertyStorage } from '../../../Property/propertyStorage';
import { IProprietaryTimerStorage } from '../../../Timer/ITimerStorage';
import { PowerActionRules } from '../../../NativeDevice/Power/IPowerActionTimer';
import { call } from 'redux-saga/effects';

const installedPackagesTelemetry = createDeviceTelemetrySaga(
	DeviceTelemetryType.INSTALLED_PACKAGES,
	Responsibility.TELEMETRY,
	[ManagementCapability.NOTIFY_INSTALLED_PACKAGES],
	getInstalledPackages,
);

// Export wrapper function that properly calls the withDependencies saga
export function* telemetryInstalledPackagesSaga(
	responsibilities: IResponsibilities,
	getManagementDriver: () => IManagementDriver,
	propertyStorage: IPropertyStorage,
	timerStorage: IProprietaryTimerStorage,
	powerActionRules: () => Promise<PowerActionRules>,
	applicationVersion: string,
) {
	// Actually call the withDependencies saga with parameters
	yield call(
		installedPackagesTelemetry,
		responsibilities,
		getManagementDriver,
		propertyStorage,
		timerStorage,
		powerActionRules,
		applicationVersion,
	);
}

export async function getInstalledPackages({
	managementDriver,
}: IGetTelemetryProperties): Promise<MonitoringLogData[DeviceTelemetryType.INSTALLED_PACKAGES]> {
	try {
		const installedPackages = await managementDriver.getInstalledPackages();
		return installedPackages;
	} catch (error) {
		throw error;
	}
}
